module.exports = __webpack_public_path__ + "img/bg-login.a2a76f6b.jpg";